import MiniVideoCallPlayer from './MiniVideoCallPlayer';

export default MiniVideoCallPlayer;
